import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type OrgRoleListItemFragment = { id: string, name: string, key?: string | null, userCount?: number | null, sampleUsers: Array<{ id: string, name?: string | null, profilePicture?: string | null }> };


export type OrgRoleListItemFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const OrgRoleListItemFragmentDoc = /*#__PURE__*/ gql`
    fragment OrgRoleListItem on OrgRoleType {
  id
  name
  key
  sampleUsers {
    id
    name
    profilePicture
  }
  userCount
}
    `;